module.exports = __webpack_public_path__ + "media/img/logos/2024/valentinstag-8e45d16732bb09795efb7a8f240426f3.svg";